import { Store, UIEventSource } from "../UIEventSource"
import { Utils } from "../../Utils"

export class IsOnline {
    private static readonly _isOnline: UIEventSource<boolean> = new UIEventSource(
        Utils.runningFromConsole || navigator.onLine
    )
    static {
        if (!Utils.runningFromConsole) {
            window.addEventListener("online", () => {
                IsOnline._isOnline.set(true)
            })

            window.addEventListener("offline", () => {
                IsOnline._isOnline.set(false)
            })
        }
    }

    public static readonly isOnline: Store<boolean> = IsOnline._isOnline
}
